import { getGlAccounts } from "@/services/gl.service";
import { useQuery } from "@tanstack/react-query";

export const useGlAccounts = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  return useQuery({
    queryKey: ["gl-accounts", params.page, params.size, params.search],
    queryFn: () => getGlAccounts(params),
    enabled,
    ...options,
  });
};
